import { Injector } from '@angular/core';
import { UserNotificationService } from 'src/app/components/notification/userNotifications.service';
import { HttpResponseHandler } from '../public_api';
import { ApiResponse } from './apiResponse.interface';

export class EvHttpResponseHandler implements HttpResponseHandler {
  private userNotificationService: UserNotificationService;
  constructor(injector: Injector) {
    this.userNotificationService = injector.get<UserNotificationService>(UserNotificationService);
  }

   
  public handleSuccess(res: ApiResponse): Promise<any> {
    // console.debug(res);
    return new Promise((resolve, reject) => {
      // validate that it has a data attribute
      if (undefined === res.data) {
        // add a message to be handled by the handleError method
        reject({
          message: 'Internally generated error: No data attribute in api response',
          response: res,
        });
      } else {
        // return the data element
        resolve(res.data);
      }
    });
  }

  /*
   * Creates an error for a promise.
   */
  public handleError(res: any): Promise<any> {
    // TODO: Check response meta
    // TODO: Output to console?
    // console.debug(res);
    const body = res.error; // .error is the body of the response?
    let returnValue: ApiResponse;
    let errorMessage = '';

    switch (true) {
      case res.ok === false:
        errorMessage = res.message;
        break;
      case res.status === 404 && typeof body !== 'string':
        returnValue = body;
        break; // just an empty dataset
      case typeof body !== 'string':
        errorMessage = body.msg;
        break;
      default:
        errorMessage = res.message;
        break;
    }
    // console.debug('error message', errorMessage, returnValue, res);

    if (errorMessage) {
      this.userNotificationService.sendNegative(errorMessage, 6000);
      return Promise.reject(errorMessage);
    } else {
      return Promise.resolve(returnValue);
    }
  }
}
